import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';

function OrderFailedPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    
    const error = searchParams.get('error') || 'Ödeme işlemi başarısız oldu.';

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
                <div className="flex justify-center mb-6">
                    <XCircle className="w-20 h-20 text-red-500" />
                </div>
                
                <h1 className="text-3xl font-bold text-gray-800 mb-4">
                    Ödeme Başarısız
                </h1>
                
                <p className="text-gray-600 mb-6">
                    {decodeURIComponent(error)}
                </p>
                
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                    <p className="text-sm text-red-700">
                        Lütfen kart bilgilerinizi kontrol edip tekrar deneyiniz veya farklı bir ödeme yöntemi seçiniz.
                    </p>
                </div>
                
                <div className="space-y-3">
                    <button
                        onClick={() => navigate('/checkout')}
                        className="w-full bg-brand-primary hover:bg-brand-secondary text-white font-semibold py-3 rounded-lg transition-colors"
                    >
                        Ödemeyi Tekrar Dene
                    </button>
                    
                    <button
                        onClick={() => navigate('/cart')}
                        className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 rounded-lg transition-colors"
                    >
                        Sepete Dön
                    </button>
                    
                    <button
                        onClick={() => navigate('/')}
                        className="w-full bg-white hover:bg-gray-50 text-gray-700 font-semibold py-3 rounded-lg border border-gray-300 transition-colors"
                    >
                        Ana Sayfaya Dön
                    </button>
                </div>
                
                <div className="mt-6 pt-6 border-t border-gray-200">
                    <p className="text-xs text-gray-500">
                        Sorun devam ederse lütfen müşteri hizmetleri ile iletişime geçiniz.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default OrderFailedPage;
